<template>
  <v-app-bar
    app
    clipped-right
    clipped-left
    flat
    height="72"
    style="background: #55a6dc"
    class="py-0"
  >
    <v-list two-line style="background: #55a6dc" class="py-0">
      <v-list-item-group
        style="display: flex; height: 72px"
        active-class="blue"
      >
        <v-list-item @click="routerTo('/')">
          <template v-if="projectType === constant.INTERNATIONAL">
            <v-list-item-content style="margin-top: -5px !important;">
             <img style="width: 100px" src="../assets/logo-rino.png">
            </v-list-item-content>
          </template>
          <template v-else>
            <v-list-item-content>
              <v-list-item-title
                  style="
                  color: white;
                  font-family: Mulish;
                  font-size: 20px;
                  font-weight: 700;
                "
              >Bitu Chat
              </v-list-item-title
              >
            </v-list-item-content>
            <svg
                style="margin-top: -18px"
                width="22"
                height="20"
                viewBox="0 0 22 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M11 0C16.799 0 21.5 3.664 21.5 8.185C21.5 12.705 16.799 16.369 11 16.369C10.4226 16.3693 9.84572 16.3326 9.273 16.259L4.865 19.142C4.364 19.407 4.187 19.378 4.393 18.729L5.285 15.051C2.405 13.591 0.5 11.061 0.5 8.185C0.5 3.665 5.201 0 11 0ZM16.907 8.06L18.377 6.636C18.4618 6.54791 18.5091 6.43033 18.509 6.30804C18.5088 6.18575 18.4612 6.0683 18.3762 5.98041C18.2912 5.89252 18.1753 5.84107 18.0531 5.83689C17.9309 5.83271 17.8118 5.87613 17.721 5.958L15.793 7.824V6.282C15.793 6.15682 15.7433 6.03676 15.6548 5.94825C15.5662 5.85973 15.4462 5.81 15.321 5.81C15.1958 5.81 15.0758 5.85973 14.9872 5.94825C14.8987 6.03676 14.849 6.15682 14.849 6.282V8.839C14.8313 8.91194 14.8313 8.98806 14.849 9.061V10.5C14.849 10.6252 14.8987 10.7452 14.9872 10.8338C15.0758 10.9223 15.1958 10.972 15.321 10.972C15.4462 10.972 15.5662 10.9223 15.6548 10.8338C15.7433 10.7452 15.793 10.6252 15.793 10.5V9.137L16.22 8.724L17.648 10.757C17.6837 10.8078 17.729 10.851 17.7813 10.8842C17.8337 10.9175 17.8921 10.9401 17.9532 10.9508C18.0143 10.9615 18.0769 10.96 18.1374 10.9465C18.198 10.933 18.2552 10.9077 18.306 10.872C18.3568 10.8363 18.4 10.791 18.4332 10.7387C18.4665 10.6863 18.4891 10.6279 18.4998 10.5668C18.5105 10.5057 18.509 10.4431 18.4955 10.3826C18.482 10.322 18.4567 10.2648 18.421 10.214L16.907 8.059V8.06ZM13.949 9.984H12.489V6.297C12.4834 6.17571 12.4313 6.06123 12.3435 5.97737C12.2557 5.89351 12.1389 5.84672 12.0175 5.84672C11.8961 5.84672 11.7793 5.89351 11.6915 5.97737C11.6037 6.06123 11.5516 6.17571 11.546 6.297V10.456C11.546 10.716 11.756 10.928 12.017 10.928H13.949C14.0742 10.928 14.1942 10.8783 14.2828 10.7898C14.3713 10.7012 14.421 10.5812 14.421 10.456C14.421 10.3308 14.3713 10.2108 14.2828 10.1222C14.1942 10.0337 14.0742 9.984 13.949 9.984ZM8.092 8.892L8.788 7.185L9.426 8.892H8.092ZM10.615 9.38L10.617 9.364C10.6168 9.24509 10.5714 9.13071 10.49 9.044L9.444 6.244C9.40015 6.11057 9.31663 5.99369 9.20459 5.90899C9.09255 5.8243 8.95733 5.7758 8.817 5.77C8.67564 5.76938 8.53744 5.81182 8.42079 5.89167C8.30414 5.97152 8.21457 6.08499 8.164 6.217L6.503 10.292C6.47956 10.3494 6.46765 10.4108 6.46796 10.4728C6.46826 10.5348 6.48077 10.5961 6.50478 10.6533C6.52878 10.7104 6.56381 10.7623 6.60785 10.8059C6.6519 10.8495 6.70411 10.8841 6.7615 10.9075C6.81889 10.9309 6.88033 10.9428 6.94232 10.9425C7.00431 10.9422 7.06563 10.9297 7.12279 10.9057C7.17994 10.8817 7.23181 10.8467 7.27543 10.8026C7.31904 10.7586 7.35356 10.7064 7.377 10.649L7.707 9.836H9.777L10.076 10.636C10.0963 10.6958 10.1285 10.7509 10.1705 10.7981C10.2125 10.8452 10.2635 10.8835 10.3206 10.9105C10.3777 10.9376 10.4396 10.9529 10.5027 10.9557C10.5658 10.9584 10.6288 10.9484 10.688 10.9263C10.7471 10.9042 10.8013 10.8704 10.8472 10.8271C10.8931 10.7837 10.9298 10.7315 10.9551 10.6737C10.9805 10.6158 10.994 10.5535 10.9948 10.4903C10.9957 10.4272 10.9838 10.3645 10.96 10.306L10.615 9.38ZM7.293 6.302C7.293 6.17699 7.24341 6.05709 7.15511 5.9686C7.06681 5.88011 6.94701 5.83026 6.822 5.83H3.577C3.45182 5.83 3.33176 5.87973 3.24325 5.96825C3.15473 6.05676 3.105 6.17682 3.105 6.302C3.105 6.42718 3.15473 6.54724 3.24325 6.63575C3.33176 6.72427 3.45182 6.774 3.577 6.774H4.737V10.51C4.737 10.6352 4.78673 10.7552 4.87525 10.8438C4.96376 10.9323 5.08382 10.982 5.209 10.982C5.33418 10.982 5.45424 10.9323 5.54275 10.8438C5.63127 10.7552 5.681 10.6352 5.681 10.51V6.774H6.821C7.082 6.774 7.293 6.562 7.293 6.302Z"
                  fill="white"
              />
            </svg>
          </template>
        </v-list-item>
        <v-list-item
          :class="{ active: $route.name == constant.CHAT }"
          @click="routerTo('/chat')"
        >
          <span v-if="$store.state.totalUnRead > 0 && $store.state.totalUnRead <= 99" class="couter">{{
            $store.state.totalUnRead
          }}</span>
          <span v-else-if="$store.state.totalUnRead > 99" class="couter">
            99+
          </span>
          <v-list-item-content>
            <v-list-item-title style="color: white" class="mt-1 ml-1">
              <router-link
                style="color: white; text-decoration: none"
                to="/chat"
                >Hội thoại</router-link
              >
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :class="{ active: $route.name == constant.CUSTOMER }"
          @click="routerTo('/customer')"
        >
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 0V10.2816L6.7184 17H17V0H0ZM13.3715 10.9358H7.68774V9.31146L1.19255 9.31213V1.19258H15.808V15.808H7.68774V12.5601H13.3715C13.8204 12.5601 14.183 12.1969 14.183 11.748C14.1837 11.2991 13.8204 10.9359 13.3715 10.9359V10.9358ZM6.87565 10.1243V15.472L1.52864 10.1243H6.87565ZM2.81622 3.62841C2.81622 3.17951 3.17946 2.81627 3.62836 2.81627H13.3721C13.821 2.81627 14.1836 3.17951 14.1836 3.62841C14.1836 4.07731 13.8203 4.44055 13.3721 4.44055L3.62836 4.43989C3.17946 4.43989 2.81622 4.07665 2.81622 3.62841V3.62841ZM14.1836 7.68784C14.1836 8.13674 13.8204 8.49998 13.3721 8.49998H3.62841C3.17951 8.49998 2.81627 8.13674 2.81627 7.68784C2.81627 7.23894 3.17951 6.8757 3.62841 6.8757H13.3721C13.8204 6.8757 14.1836 7.2396 14.1836 7.68784Z"
              fill="white"
            />
          </svg>

            <v-list-item-content>
            <v-list-item-title style="color: white" class="mt-1 ml-1"
              ><router-link
                style="color: white; text-decoration: none"
                to="/customer"
                >Khách hàng</router-link
              ></v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          :class="{ active: $route.name == constant.SETTING }"
          @click="routerTo('/setting')"
        >
          <svg
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16.121 6.61183H14.5299C14.2809 6.61647 14.0558 6.46507 13.9655 6.23264C13.8639 6.00554 13.917 5.73859 14.0983 5.56791L15.2239 4.44232C15.5639 4.10166 15.5639 3.54915 15.2239 3.20849L13.7888 1.77345C13.4428 1.44209 12.897 1.44209 12.551 1.77345L11.4254 2.89904H11.4261C11.2515 3.07302 10.9898 3.12482 10.762 3.03053C10.5349 2.93556 10.3869 2.7131 10.3875 2.4674V0.879634C10.3875 0.646546 10.2959 0.423421 10.1319 0.258742C9.96717 0.0940548 9.74471 0.00109025 9.51163 0.000427246H7.4803C6.99553 0.000427246 6.60306 0.392889 6.60306 0.877662V2.46743C6.60373 2.71314 6.45564 2.9356 6.22787 3.03056C6.00077 3.12486 5.73846 3.07306 5.56448 2.89907L4.4389 1.77349C4.09291 1.44212 3.54706 1.44212 3.20109 1.77349L1.76606 3.20853H1.76672C1.42672 3.54919 1.42672 4.10169 1.76672 4.44235L2.89032 5.56993C3.06496 5.74391 3.11742 6.00688 3.02313 6.23533C2.92817 6.46309 2.70571 6.61184 2.45868 6.61184H0.877543C0.396103 6.61051 0.00430373 6.99898 0.000308734 7.48044V9.52044C-0.00035532 9.75353 0.0919489 9.97665 0.256635 10.1413C0.42132 10.306 0.644439 10.3983 0.877526 10.3977H2.4673C2.71631 10.393 2.94144 10.5444 3.03109 10.7768C3.12605 11.0026 3.0696 11.2643 2.89031 11.431L1.76472 12.5565C1.42472 12.8979 1.42472 13.4497 1.76472 13.791L3.19976 15.2261V15.2254C3.54574 15.5574 4.09159 15.5574 4.43756 15.2254L5.56315 14.0998L5.56248 14.1005C5.73712 13.9265 5.99877 13.874 6.22654 13.969C6.45364 14.0633 6.60173 14.2858 6.60106 14.5321V16.1219V16.1212C6.60106 16.355 6.69337 16.5788 6.85805 16.7435C7.02341 16.9082 7.2472 17.0011 7.48029 17.0005H9.52029C9.75271 17.0005 9.97583 16.9081 10.1405 16.7435C10.3052 16.5788 10.3975 16.3557 10.3975 16.1232V14.5321C10.3929 14.2838 10.5423 14.0593 10.7734 13.9677C11.0005 13.8661 11.2674 13.9192 11.4381 14.1005L12.5637 15.2261L12.563 15.2254C12.909 15.5574 13.4549 15.5574 13.8008 15.2254L15.2359 13.7904V13.791C15.5759 13.4497 15.5759 12.8979 15.2359 12.5566L14.1103 11.431C13.9356 11.257 13.8832 10.994 13.9775 10.7656C14.0724 10.5378 14.2949 10.3891 14.5419 10.3891H16.1317C16.6091 10.3844 16.9956 9.99858 17.0003 9.52046V7.48046C16.9936 6.99968 16.6025 6.61252 16.1211 6.61186L16.121 6.61183ZM8.50025 10.7104C7.60643 10.7104 6.80025 10.1718 6.45821 9.34638C6.11623 8.52028 6.30548 7.57005 6.93767 6.93782C7.56985 6.30559 8.52013 6.11638 9.34623 6.45837C10.1717 6.80036 10.7102 7.60653 10.7102 8.50041C10.7102 9.72096 9.72075 10.7104 8.5002 10.7104L8.50025 10.7104Z"
              fill="white"
            />
          </svg>

          <v-list-item-content>
            <v-list-item-title class="mt-1 ml-1"
              ><router-link
                style="color: white; text-decoration: none"
                to="/setting"
                >Cài đặt</router-link
              ></v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
    <v-spacer></v-spacer>
      <v-tooltip v-if="detailPageShift && detailPageShift.checkinAt && !detailPageShift.checkoutAt" bottom>
          <template v-slot:activator="{ on, attrs }">
<!--              <v-btn outlined v-bind="attrs" v-on="on" color="white" class="mr-6">-->
              <svg @click="openDialogClose" style="cursor:pointer" class="mr-6" v-bind="attrs" v-on="on"  width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M23.9951 9.49333H14.9564L18.6092 5.73333C14.9697 2.13333 9.07715 2 5.43764 5.6C1.79813 9.21333 1.79813 15.04 5.43764 18.6533C9.07715 22.2667 14.9697 22.2667 18.6092 18.6533C20.4223 16.8667 21.3288 14.7733 21.3288 12.1333H23.9951C23.9951 14.7733 22.822 18.2 20.4756 20.52C15.7962 25.16 8.19727 25.16 3.5179 20.52C-1.14813 15.8933 -1.18813 8.37333 3.49124 3.74667C8.17061 -0.88 15.6763 -0.88 20.3556 3.74667L23.9951 0V9.49333ZM12.6633 6.66667V12.3333L17.3294 15.1067L16.3695 16.72L10.6636 13.3333V6.66667H12.6633Z" fill="#8DFFAD"/>
              </svg>
<!--              </v-btn>-->
          </template>
          <span>Chốt ca</span>
      </v-tooltip>
      <v-tooltip v-if="detailPageShift && detailPageShift.checkinAt && detailPageShift.checkoutAt" bottom>
          <template v-slot:activator="{ on, attrs }">
            <svg style="cursor:pointer" v-bind="attrs" v-on="on" class="mr-6" width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M24 11.5L21.3382 8.44429L21.7091 4.40286L17.7709 3.50476L15.7091 0L12 1.59905L8.29091 0L6.22909 3.49381L2.29091 4.38095L2.66182 8.43333L0 11.5L2.66182 14.5557L2.29091 18.6081L6.22909 19.5062L8.29091 23L12 21.39L15.7091 22.989L17.7709 19.4952L21.7091 18.5971L21.3382 14.5557L24 11.5ZM9.91636 16.6695L5.77091 12.4967L7.38545 10.8757L9.91636 13.4276L16.2982 6.99857L17.9127 8.61952L9.91636 16.6695Z" fill="#50E056"/>
            </svg>
          </template>
          <span>Kết thúc ca làm</span>
      </v-tooltip>
      <v-menu transition="slide-x-transition" offset-x left
        offset-y bottom >
      <template v-slot:activator="{ on, attrs }">
        <v-icon v-bind="attrs" v-on="on" color="white" class="mr-6"
          >mdi-account</v-icon
        >
      </template>
      <v-list>
        <v-list-item class="log-out" @click="viewProfile()"> <v-icon>mdi-account</v-icon> <span class="mx-2">My Profile</span></v-list-item>
        <v-list-item class="log-out" @click="logOut"> <v-icon>mdi-logout</v-icon> <span class="mx-2">Log out</span></v-list-item>
      </v-list>
    </v-menu>
    <v-responsive max-width="50">
      <v-badge
        v-show="$store.state.totalUnRead"
        bordered
        top
        color="red accent-4"
        dot
        offset-x="-17"
        offset-y="-7"
      >
      </v-badge>
      <v-icon color="white">mdi-bell</v-icon>
    </v-responsive>
    <template v-if="projectType !== 'INTERNATIONAL' && isShowPopup">
      <login-reminder-popup/>
    </template>
  </v-app-bar>
</template>

<script>
import { constant } from "../helpers/constant";
import { chatService } from "../repositories/ChatService";
import  TokenService from "../helpers/token"
import EventBus from "@/plugins/eventBus";
import LoginReminderPopup from "../../vh-fe-share-modules/src/components/rino-edu/loginReminderPopup.vue";
import eventBus from "@/plugins/eventBus";
export default {
  name: "vh-app-bar",
  components: {LoginReminderPopup},
  data: () => ({
    drawer: null,
    constant,
    projectType: process.env.VUE_APP_NATIONAL_PROJECT_TYPE || null,
    isShowPopup: false,
  }),
  mounted() {
    if(this.$route.path && ['/', '/chat'].includes(this.$route.path)) {
      eventBus.$on("open-login-reminder-popup", () => {
        setTimeout(() => {
          this.isShowPopup = true
        },100)
      });
    }else {
      this.isShowPopup = true
    }
    this.getConversationCreated();
  },
  computed: {
      detailPageShift() {
       return this.$store.state.detailPageShift;
      }
  },
  methods: {
    openDialogClose() {
        EventBus.$emit('open-close-shift')
    },
    routerTo(to) {
      this.$router.push(to);
    },
    getConversationCreated() {
      const params = {
        conv_type: "all",
      };
      // Get chatData
      chatService
        .getUnreadConversation(params)
        .then((res) => {
          this.$store.dispatch("SET_TOTALUNREAD", res.data.unread_count);
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: err.message,
            showConfirmButton: false,
            timer: 1500,
          });
        });
    },
    logOut() {
      TokenService.removeRefreshToken()
        TokenService.removeToken()
        TokenService.removeUser()
        TokenService.removePermissions()
        TokenService.removeModule()
        window.location.reload();
    },
    viewProfile() {
      this.$router.push("/profile");
    },
  },
  beforeDestroy() {
    eventBus.$off('open-login-reminder-popup')
  },
};
</script>
<style scoped lang="scss">
.couter {
  background: red;
  color: #fff;
  padding: 2px 5px;
  border-radius: 50%;
  border: 2px solid #ffff;
  font-size: 10px;
}
.active {
  background: #1472af;
}
.log-out {
  cursor: pointer;
}
</style>
